// src/pages/Terms.js
import React from 'react';
import { Container, Typography, Paper } from '@mui/material';

const Terms = () => {
    return (
        <Container maxWidth="lg">
            <Paper elevation={0} sx={{ p: 4, my: 4 }}>
                <Typography variant="h4" gutterBottom>
                    Terms and Conditions of Use
                </Typography>
                <Typography variant="body2" color="text.secondary" paragraph>
                    Last Updated: January 25, 2025
                </Typography>

                <Typography paragraph sx={{ mt: 3 }}>
                    ArgusCMS is a product developed by wpAppDev, a division of iMarket LLC. By accessing and using ArgusCMS and iMarketLLC.com, hereby referred to as iMarket LLC, you are agreeing to be bound by these Terms and Conditions of Use, all applicable laws and regulations, and agree that you are responsible for compliance with any applicable local laws.
                </Typography>

                <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
                    ArgusCMS Subscription and Billing Terms
                </Typography>
                <Typography paragraph>
                    By subscribing to ArgusCMS, you explicitly authorize us to:
                </Typography>
                <Typography component="ul" sx={{ pl: 3, mb: 3 }}>
                    <li>Store your payment method for recurring charges</li>
                    <li>Process monthly subscription fees using stored payment methods</li>
                    <li>Charge for additional services or add-ons as authorized</li>
                    <li>Process automatic renewal payments</li>
                </Typography>

                <Typography variant="h6" gutterBottom>
                    Refund Policy
                </Typography>
                <Typography paragraph>
                    For ArgusCMS services, our refund policy includes:
                </Typography>
                <Typography component="ul" sx={{ pl: 3, mb: 3 }}>
                    <li>30-day money-back guarantee for new accounts, excluding hard costs</li>
                    <li>Non-refundable third-party expenses (domain registrations, etc.)</li>
                    <li>No refunds for subscription fees beyond the initial 30-day period</li>
                    <li>Purchased assets (domains, etc.) remain client property after refund</li>
                </Typography>

                <Typography variant="h6" gutterBottom>
                    Use License
                </Typography>
                <Typography paragraph>
                    Permission is granted to temporarily download one copy of the materials (information or software) on this website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:
                </Typography>
                <Typography component="ul" sx={{ pl: 3, mb: 3 }}>
                    <li>modify or copy the materials;</li>
                    <li>use the materials for any commercial purpose, or for any public display (commercial or non-commercial);</li>
                    <li>attempt to decompile or reverse engineer any software contained on this site;</li>
                    <li>remove any copyright or other proprietary notations from the materials; or</li>
                    <li>transfer the materials to another person or "mirror" the materials on any other server.</li>
                </Typography>
                <Typography paragraph>
                    This license shall automatically terminate if you violate any of these restrictions and may be terminated by iMarket LLC at any time. Upon terminating your viewing of these materials or upon the termination of this license, you must destroy any downloaded materials in your possession whether in electronic or printed format.
                </Typography>

                <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
                    Disclaimer
                </Typography>
                <Typography paragraph>
                    The materials on this site are provided "as is". The publisher makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties, including without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights. Further, iMarket LLC does not warrant or make any representations concerning the accuracy, likely results, or reliability of the use of the materials on its Internet website or otherwise relating to such materials or on any sites linked to this site.
                </Typography>

                <Typography variant="h6" gutterBottom>
                    Limitations
                </Typography>
                <Typography paragraph>
                    In no event shall this site or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption,) arising out of the use or inability to use the materials on this site, even if iMarket LLC or an authorized representative has been notified orally or in writing of the possibility of such damage. Because some jurisdictions do not allow limitations on implied warranties, or limitations of liability for consequential or incidental damages, these limitations may not apply to you.
                </Typography>

                <Typography variant="h6" gutterBottom>
                    Revisions and Errata
                </Typography>
                <Typography paragraph>
                    The materials appearing on this website could include technical, typographical, or photographic errors. iMarket LLC does not warrant that any of the materials on its website are accurate, complete, or current. iMarket LLC may make changes to the materials contained on its website at any time without notice. iMarket LLC does not, however, make any commitment to update the materials.
                </Typography>

                <Typography variant="h6" gutterBottom>
                    Links
                </Typography>
                <Typography paragraph>
                    iMarket LLC has not reviewed all of the sites linked to its Internet website and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by this site. Use of any such linked website is at the user's own risk.
                </Typography>

                <Typography variant="h6" gutterBottom>
                    Site Terms of Use Modifications
                </Typography>
                <Typography paragraph>
                    These terms may be revised at any time without notice. By using this website you are agreeing to be bound by the then current version of these Terms and Conditions of Use.
                </Typography>

                <Typography variant="h6" gutterBottom>
                    Governing Law
                </Typography>
                <Typography paragraph>
                    Any claim relating to this website shall be governed by the laws of the State of Missouri without regard to its conflict of law provisions.
                </Typography>

                <Typography variant="h6" gutterBottom>
                    Service Termination
                </Typography>
                <Typography paragraph>
                    We reserve the right to suspend or terminate ArgusCMS accounts for:
                </Typography>
                <Typography component="ul" sx={{ pl: 3, mb: 3 }}>
                    <li>Violation of these terms</li>
                    <li>Non-payment of fees</li>
                    <li>Fraudulent or illegal activities</li>
                    <li>Abuse of service resources</li>
                </Typography>
            </Paper>
        </Container>
    );
};

export default Terms;